
// Switch between dev and production automatically
const BASE_URL = process.env.NODE_ENV === "production"
  ? "https://app.radheshyamtravels.com/"   // ← live backend
  : "http://localhost:3000/";               // ← local backend

export default BASE_URL;
